import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { colors } from '@/theme/colors';
const iconMap = {
    phone: '📱',
    mail: '📧',
    environment: '🏢',
    clock: '⏰',
    whatsapp: '💬',
    telegram: '📲',
    'phone-call': '📞',
};
export const Icon = ({ type, size = 24, color, className = '', }) => {
    const icon = iconMap[type];
    if (!icon) {
        console.warn(`Icon type "${type}" not found`);
        return null;
    }
    return (_jsx(StyledIcon, { size: size, color: color, className: `legarta-icon legarta-icon--${type} ${className}`, children: icon }));
};
const StyledIcon = styled.span `
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ size }) => size}px;
  color: ${({ color }) => color || colors.primary};
  line-height: 1;
  
  &.legarta-icon--phone {
    color: ${({ color }) => color || colors.primary};
  }
  
  &.legarta-icon--mail {
    color: ${({ color }) => color || colors.primary};
  }
  
  &.legarta-icon--environment {
    color: ${({ color }) => color || colors.primary};
  }
  
  &.legarta-icon--clock {
    color: ${({ color }) => color || colors.primary};
  }
  
  &.legarta-icon--whatsapp {
    color: ${({ color }) => color || '#25D366'};
  }
  
  &.legarta-icon--telegram {
    color: ${({ color }) => color || '#0088cc'};
  }
  
  &.legarta-icon--phone-call {
    color: ${({ color }) => color || colors.primary};
  }
`;
